import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

export const DrawerContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '300px',
  width: '100%'
});

export const NavSection = styled('div')({
  margin: '16px 32px',
  '@media (max-width: 1024px)': {
    margin: '32px 80px 16px 80px'
  },
  '@media (max-width: 768px)': {
    margin: '32px 24px 16px 24px'
  }
});

export const NavButton = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive'
})<{ isActive?: boolean }>(({ isActive }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  margin: '8px 0',
  borderRadius: 4,
  cursor: 'pointer',
  letterSpacing: '0.15px',
  textDecoration: 'none',
  fontFamily: 'Roboto',
  fontSize: 16,
  lineHeight: '150%',
  color: '#1C3D64',
  '&:first-of-type': {
    marginTop: 82
  },
  '&:hover': {
    background: '#F0F1F4',
    fontWeight: 500
  },
  ...(isActive && {
    background: '#F0F1F4',
    fontWeight: 500
  })
}));
